import { useContext } from 'react';
import { ChatContext } from '../contexts/chat-contexts';

export default function useChat() {
  return useContext(ChatContext);
}
